import { fromRefinement } from './fromRefinement';
var isDate = function (u) { return u instanceof Date; };
/**
 * @since 0.5.0
 */
export var date = fromRefinement('Date', isDate);
